const initFooterInputEvents = () => {
  // Elements
  const formInputs = $(
    '.tt-courses__contact-form-form > div > input, .tt-courses__contact-form-form > div > textarea'
  );

  const formDateInput = $('.tt-footer-v2__form-date-input');

  // onFocus Footer Form Input
  formInputs.on('focus', function () {
    $(this).parent('[placeholder]').addClass('focused');

    if ($(this).hasClass('tt-footer-v2__form-date-input')) {
      $(this).prop('type', 'week');
    }
  });

  // onBlur Footer Form Input
  formInputs.on('blur', function () {
    if (($(this).val() as string).length == 0) {
      $(this).parent('[placeholder]').removeClass('focused');

      if ($(this).hasClass('tt-footer-v2__form-date-input')) {
        $(this).prop('type', 'text');
      }
    }
  });

  // onMouseover Date Input
  formDateInput.on('mouseover', function () {
    $(this).parent('[placeholder]').addClass('focused');
    $(this).prop('type', 'week');
  });

  // onMouseout Date Input
  formDateInput.on('mouseout', function () {
    if (($(this).val() as string).length == 0) {
      $(this).parent('[placeholder]').removeClass('focused');
      $(this).prop('type', 'text').trigger('blur');
    }
  });
};

export default initFooterInputEvents;
